import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Teleport as _Teleport, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6996cc60"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-tablet-add" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-add-folder" }, null, -1))
const _hoisted_3 = {
  for: "mediaInput",
  class: "btn-ico"
}
const _hoisted_4 = { class: "text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1))
const _hoisted_6 = { class: "text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1))
const _hoisted_8 = { class: "text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-videocam" }, null, -1))
const _hoisted_10 = {
  key: 4,
  for: "fileInputTUS"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_take_photo = _resolveComponent("app-take-photo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_bottom_pop_up, {
      onHide: _ctx.hidePopUp,
      "hide-bottom-decoration": "",
      "hide-top-decoration": ""
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$localize('drive.button.add.title')), 1)
      ]),
      body: _withCtx(() => [
        _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.addCase }, {
          icon: _withCtx(() => [
            _hoisted_1
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$localize('drive.button.add.case')) + " ", 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.showNewFolder)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 0,
              onClick: _ctx.addFolder
            }, {
              icon: _withCtx(() => [
                _hoisted_2
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('drive.button.add.folder')) + " ", 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, { key: 1 }, {
              icon: _withCtx(() => [
                _hoisted_5
              ]),
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$localize('drive.button.add.picture')), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, { key: 2 }, {
              icon: _withCtx(() => [
                _hoisted_7
              ]),
              default: _withCtx(() => [
                _createElementVNode("label", {
                  for: "mediaInput",
                  class: "btn-ico",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.CAMERA_IMAGE)))
                }, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$localize('drive.button.add.camera.image')), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, { key: 3 }, {
              icon: _withCtx(() => [
                _hoisted_9
              ]),
              default: _withCtx(() => [
                _createElementVNode("label", {
                  for: "mediaInput",
                  class: "btn-ico",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.CAMERA_VIDEO)))
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$localize('drive.button.add.camera.video')), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createElementBlock("input", {
          id: "mediaInput",
          ref: "mediaInputRef",
          key: _ctx.mediaLoadedKey,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addMedia($event))),
          accept: "video/*, image/*",
          capture: "environment",
          type: "file"
        }, null, 544)), [
          [_vShow, false]
        ]),
        (!_ctx.mainStore.isAndroid)
          ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
              _createVNode(_component_bottom_pop_up_item, null, {
                icon: _withCtx(() => [
                  _hoisted_11
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('drive.button.add.files')) + " ", 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
          ? (_openBlock(), _createElementBlock("label", {
              key: 5,
              for: "fileInputTUS",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.GALLERY)))
            }, [
              _createVNode(_component_bottom_pop_up_item, null, {
                icon: _withCtx(() => [
                  _hoisted_12
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('drive.button.add.upload.gallery')) + " ", 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
          ? (_openBlock(), _createElementBlock("label", {
              key: 6,
              for: "fileInputTUS",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.FILE)))
            }, [
              _createVNode(_component_bottom_pop_up_item, null, {
                icon: _withCtx(() => [
                  _hoisted_13
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('drive.button.add.upload.files')) + " ", 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.mainStore.isFlutter)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 7,
              "data-type": "flutter",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.flutterOpenCamera()))
            }, {
              icon: _withCtx(() => [
                _hoisted_14
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('drive.button.add.picture')) + " ", 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.mainStore.isFlutter)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 8,
              "data-type": "flutter",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.flutterOpenImagePicker()))
            }, {
              icon: _withCtx(() => [
                _hoisted_15
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('drive.button.add.upload.gallery')) + " ", 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.mainStore.isFlutter)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 9,
              "data-type": "flutter",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.flutterOpenFilePicker()))
            }, {
              icon: _withCtx(() => [
                _hoisted_16
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('drive.button.add.upload.files')) + " ", 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          id: "fileInputTUS",
          ref: "fileInputTUS",
          onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.uploadTUS($event))),
          style: {"display":"none"},
          type: "file",
          multiple: ""
        }, null, 544)
      ]),
      _: 1
    }, 8, ["onHide"]),
    (_ctx.isSaving)
      ? (_openBlock(), _createBlock(_component_app_loader, {
          key: 0,
          message: _ctx.loaderText
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
      _createVNode(_component_app_take_photo, {
        ref: "appTakePhoto",
        image: _ctx.mediaToCrop,
        labels: _ctx.labels,
        onOnCancel: _ctx.handleMediaCancel,
        onOnDone: _ctx.handleMultipleUpload,
        onOnRetake: _ctx.handleRetake,
        "z-index": "3500",
        "is-case-cropper": ""
      }, null, 8, ["image", "labels", "onOnCancel", "onOnDone", "onOnRetake"])
    ]))
  ], 64))
}